// docs https://github.com/azouaoui-med/react-pro-sidebar
import { useState, useEffect } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import logo from '../assets/img/codeflare-app.webp';
import user from '../assets/img/codeflare-app.webp';
import { useSidebarContext } from "./SidebarContext";
import Greet  from '../components/GreetUser';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { tokens } from "../theme";
import { useTheme, Box, Typography, IconButton } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import VideocamIcon from '@mui/icons-material/Videocam';
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import LoyaltyOutlinedIcon from "@mui/icons-material/LoyaltyOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import SwitchRightOutlinedIcon from "@mui/icons-material/SwitchRightOutlined";
import SwitchLeftOutlinedIcon from "@mui/icons-material/SwitchLeftOutlined";

const MyProSidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("");
  const { sidebarRTL, setSidebarRTL, sidebarImage } = useSidebarContext();
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();
  const location = useLocation();
  const navigate = useNavigate();

  // Set selected based on current path
  useEffect(() => {
    const path = location.pathname;
    
    if (path.includes("dashboard")) setSelected("Dashboard");
    else if (path.includes("course-catalogue")) setSelected("Courses");
    else if (path.includes("tracks")) setSelected("Tracks");
    else if (path.includes("videos")) setSelected("Videos");
    else if (path.includes("discussions")) setSelected("Discussions");
    else if (path.includes("quiz")) setSelected("Assessment");
    else if (path.includes("active-track")) setSelected("My Tracks");
    else if (path.includes("plans") || path.includes("subscription-plans")) setSelected("Plans");
    else if (path.includes("profile")) setSelected("Profile");
    else if (path.includes("faq")) setSelected("FAQs");
    else if (path.includes("logout")) setSelected("Logout");
    else setSelected("Dashboard");
  }, [location.pathname]);

  // Handle menu item click
  const handleMenuItemClick = (path, title) => {
    setSelected(title);
    navigate(path);
  };

  // Check if a menu item is active
  const isItemActive = (path) => {
    return location.pathname.includes(path);
  };

  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 10000,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          padding: "5px 35px 5px 20px !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          color: `${colors.blueAccent[100]} !important`,
          backgroundColor: `${colors.blueAccent[800]} !important`,
        },
        "& .menu-item.active": {
          color: `${colors.blueAccent[500]} !important`,
          backgroundColor: `${colors.blueAccent[800]} !important`,
          borderRight: `4px solid ${colors.blueAccent[500]} !important`,
        },
        "& .ps-menu-button": {
          transition: "all 0.3s ease !important",
        },
        "& .ps-menu-button:hover": {
          backgroundColor: `${colors.blueAccent[800]} !important`,
          transform: "translateX(5px)",
        },
        "& .ps-active": {
          color: `${colors.blueAccent[500]} !important`,
          backgroundColor: `${colors.blueAccent[800]} !important`,
          borderRight: `4px solid ${colors.blueAccent[500]} !important`,
        },
      }}
    >
      <Sidebar
        breakPoint="md"
        rtl={sidebarRTL}
        backgroundColor={colors.primary[200]}
        image={sidebarImage}
      >
        <Menu 
          iconshape="square"
          menuItemStyles={{
            button: ({ level, active, disabled }) => {
              if (level === 0) {
                return {
                  color: active ? colors.blueAccent[500] : colors.white[100],
                  backgroundColor: active ? colors.blueAccent[800] : 'transparent',
                  borderRight: active ? `4px solid ${colors.blueAccent[500]}` : 'none',
                  fontWeight: active ? 'bold' : 'normal',
                  '&:hover': {
                    backgroundColor: colors.blueAccent[800],
                    color: colors.blueAccent[100],
                    transform: 'translateX(5px)',
                  },
                };
              }
              return {};
            },
          }}
        >
          <MenuItem
            icon={
              collapsed ? (
                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
              ) : sidebarRTL ? (
                <SwitchLeftOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              ) : (
                <SwitchRightOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              )
            }
            style={{
              margin: "10px 0 20px 0",
              color: colors.blueAccent[100],
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!collapsed && (
            <Box mb="25px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .avater-image": {
                    backgroundColor: colors.primary[500],
                  },
                }}
              >
                <Link to="/" style={{ textDecoration: 'none' }}>
                  <img
                    className="avater-image"
                    alt="profile user"
                    width="100px"
                    height="100px"
                    src={user}
                    style={{ cursor: "pointer", borderRadius: "50%" }}
                  />
                </Link>
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.white[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                  style={{ textAlign: 'center' }}
                >
                  <Greet />
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={collapsed ? undefined : "1%"}>

            {/* Dashboard */}
            <MenuItem 
              active={isItemActive("dashboard")}
              icon={<HomeOutlinedIcon />}
              onClick={() => handleMenuItemClick("/dashboard", "Dashboard")}
              style={{
                color: isItemActive("dashboard") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("dashboard") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("dashboard") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("dashboard") ? 'bold' : 'normal',
              }}
            >
              Dashboard
            </MenuItem>

            {/* Courses */}
            <MenuItem 
              active={isItemActive("course-catalogue")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/course-catalogue", "Courses")}
              style={{
                color: isItemActive("course-catalogue") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("course-catalogue") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("course-catalogue") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("course-catalogue") ? 'bold' : 'normal',
              }}
            >
              Courses
            </MenuItem>

            {/* Tracks */}
            <MenuItem 
              active={isItemActive("tracks")}
              icon={<LibraryBooksOutlinedIcon />}
              onClick={() => handleMenuItemClick("/tracks", "Tracks")}
              style={{
                color: isItemActive("tracks") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("tracks") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("tracks") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("tracks") ? 'bold' : 'normal',
              }}
            >
              Tracks
            </MenuItem>

            {/* Videos */}
            <MenuItem 
              active={isItemActive("videos")}
              icon={<VideocamIcon />}
              onClick={() => handleMenuItemClick("/videos", "Videos")}
              style={{
                color: isItemActive("videos") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("videos") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("videos") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("videos") ? 'bold' : 'normal',
              }}
            >
              Videos
            </MenuItem>

            {/* Assessment */}
            <MenuItem 
              active={isItemActive("quiz")}
              icon={<LocalLibraryOutlinedIcon />}
              onClick={() => handleMenuItemClick("/quiz", "Assessment")}
              style={{
                color: isItemActive("quiz") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("quiz") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("quiz") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("quiz") ? 'bold' : 'normal',
              }}
            >
              Assessment
            </MenuItem>

            {/* My Tracks */}
            <MenuItem 
              active={isItemActive("active-track")}
              icon={<AssignmentIndOutlinedIcon />}
              onClick={() => handleMenuItemClick("/active-track", "My Tracks")}
              style={{
                color: isItemActive("active-track") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("active-track") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("active-track") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("active-track") ? 'bold' : 'normal',
              }}
            >
              My Tracks
            </MenuItem>

            {/* Plans */}
            <MenuItem 
              active={isItemActive("plans") || isItemActive("subscription-plans")}
              icon={<LoyaltyOutlinedIcon />}
              onClick={() => handleMenuItemClick("/plans", "Plans")}
              style={{
                color: (isItemActive("plans") || isItemActive("plans")) ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: (isItemActive("plans") || isItemActive("plans")) ? colors.blueAccent[800] : 'transparent',
                borderRight: (isItemActive("plans") || isItemActive("plans")) ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: (isItemActive("plans") || isItemActive("plans")) ? 'bold' : 'normal',
              }}
            >
              Plans
            </MenuItem>

            {/* Profile */}
            <MenuItem 
              active={isItemActive("profile")}
              icon={<AccountBoxOutlinedIcon />}
              onClick={() => handleMenuItemClick("/profile", "Profile")}
              style={{
                color: isItemActive("profile") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("profile") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("profile") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("profile") ? 'bold' : 'normal',
              }}
            >
              Profile
            </MenuItem>

            {/* FAQs */}
            <MenuItem 
              active={isItemActive("faq")}
              icon={<HelpOutlineOutlinedIcon />}
              onClick={() => handleMenuItemClick("/faq", "FAQs")}
              style={{
                color: isItemActive("faq") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("faq") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("faq") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("faq") ? 'bold' : 'normal',
              }}
            >
              FAQs
            </MenuItem>

            {/* Logout */}
            <MenuItem 
              active={isItemActive("logout")}
              icon={<DirectionsRunOutlinedIcon />}
              onClick={() => handleMenuItemClick("/logout", "Logout")}
              style={{
                color: isItemActive("logout") ? colors.blueAccent[500] : colors.white[100],
                backgroundColor: isItemActive("logout") ? colors.blueAccent[800] : 'transparent',
                borderRight: isItemActive("logout") ? `4px solid ${colors.blueAccent[500]}` : 'none',
                fontWeight: isItemActive("logout") ? 'bold' : 'normal',
              }}
            >
              Logout
            </MenuItem>

          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default MyProSidebar;